let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bfOPI")).then(() => parcelRequire('9NuIi'));